<template>
    <el-container>
        <div class="page-hello-row">
            <p>Hi {{trueName}}. 下午好! 今天是 {{week_day}}</p>
        </div>

        <div>
            <transition name="el-zoom-in-center">
                <div class="transition-box">总路线数：{{total_all_roads}}</div>
            </transition>
            
            <transition name="el-zoom-in-center">
                <div class="transition-box">进行中路线：{{total_running_roads}}</div>
            </transition>

            <transition name="el-zoom-in-center">
                <div class="transition-box">漏检：{{total_running_roads}}</div>
            </transition>

            <transition name="el-zoom-in-center">
                <div class="transition-box">巡检人员：{{total_peoples}}</div>
            </transition>

            <transition name="el-zoom-in-center">
                <div class="transition-box">完成率：{{complete}}</div>
            </transition>

        </div>

        <el-row :gutter="20">
            <el-col :span="24">
                <div class="abnormal-box">
                    <div class="title">今日打卡记录</div>
                    <div>
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%">
                            <el-table-column
                              prop="number"
                              label="序号"
                              width="60">
                            </el-table-column>
                            <el-table-column
                              prop="create_time"
                              label="巡检时间"
                              width="180">
                            </el-table-column>
                            <el-table-column
                              prop="patrol_name"
                              label="巡检点名称">
                            </el-table-column>
                            <el-table-column
                              prop="object_name"
                              label="设备名称"
                              width="150">
                            </el-table-column>
                            <el-table-column
                              prop="device_no"
                              label="IMEI/SN"
                              width="200">
                            </el-table-column>
                            <el-table-column
                              prop="card_no"
                              label="巡检点卡号"
                              width="200">
                            </el-table-column>
                            <el-table-column
                              prop="true_name"
                              label="巡检人"
                              width="150">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="dv-pagging-container">
                        <div class="ex-sub">&nbsp;</div>
                        <el-button type="default" icon="el-icon-download" @click="exportList()" class="export-btn" size="small">导出</el-button>
                        <el-pagination
                        background
                        layout="prev, pager, next"
                        @current-change="handleCurrentChange"
                        :page-size="pagging.pager_size"
                        :pager-count="pagging.pager_count"
                        :total="pagging.records_total"
                        :current-page="pagging.current_page">
                        </el-pagination>
                    </div>
                </div>
            </el-col>
        </el-row>

        <div class="patrol_row-spacing">&nbsp;</div>

    </el-container>
</template>

<script>
import * as echarts from 'echarts'
import Api from '../api/index'

export default {
    name: 'home_dashboard',
    data() {
        return {
            trueName: "",
            week_day: "",
            total_all_roads: 0,
            total_running_roads: 0,
            total_peoples: 0,
            complete: "100%",
            tableData: [],
            pagging: {
                records_total: 0,
                pager_count: 5,
                pager_size: 20,
                current_page: 1
            }
        }
    },
    methods: {
        initHomeData: function() {
            this.trueName = localStorage.getItem("true_name") || "";

            var date = new Date();
            this.week_day = this.getWeekday(date);  // 输出当前日期的星期几

            var argdata = {};  // {HoldID:0}
            Api.GetDashboardSummary(argdata).then(res => {
                if(!res)
                    return;
                if(res.code !== 200) {
                    //this.$message.error(err);
                    return;
                }
                if(res.data) {
                    this.total_all_roads = res.data[0].all_roads;
                    this.total_running_roads = res.data[0].running_roads;
                    this.total_peoples = res.data[0].patrol_people_num;
                }
            });

            this.loadTodayPatrolLogs();
        },
        handleCurrentChange(val) {
            this.pagging.current_page = val;
            this.loadTodayPatrolLogs();
        },
        loadTodayPatrolLogs: function() {
            var argdata = {
                PageIndex: this.pagging.current_page,
                PageSize: this.pagging.pager_size
            };
            this.tableData = [];
            Api.GetTodayPatrolLogs(argdata).then(res => {
                if(!res)
                    return;
                if(res.code !== 200) {
                    //this.$message.error(err);
                    return;
                }
                if(res.data) {
                    this.pagging.records_total = res.total;
                    let startNum = (this.pagging.current_page - 1) * this.pagging.pager_size;
                    res.data.forEach((x, i) => {
                        this.tableData.push({
                            number: (startNum + (i + 1)),
                            create_time: x.create_time,
                            patrol_name: x.patrol_name,
                            card_no: x.card_no,
                            device_no: x.device_no,
                            object_name: x.object_name,
                            true_name: x.true_name
                        });
                    });
                }
            });
        },
        exportList: function() {
            // 导出全部
            var argdata = {
            };
            Api.TodayPatrolLogs_ExportList(argdata).then(res => {
                if(!res)
                    return;
                if(res.code != 200) {
                    this.$message.error(res.msg);
                }
                if(res.data) {
                    var hostStr = window.location.host;
                    var my_request = hostStr.indexOf('gps881.com') > -1 ?
                        `https://${hostStr}/proxyserver/api/file/download_excelfile?fileName=${res.data}` :
                        `http://${hostStr}/proxyserver/api/file/download_excelfile?fileName=${res.data}`;
                    window.open(my_request);
                } else {
                    this.$message.error('无数据导出！');
                }
            }).catch(err => {
                this.$message.error('错了哦，接口出错！' + err);
                this.loadingTableData = false;
            });
        },
        getWeekday: function(date) {
            var weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            return weekdays[date.getDay()];
        },
        initLineChart() {
            const chartDom = this.$refs.lineChart1;
            const myChart = echarts.init(chartDom);
            const option = {
                title: {
                  text: '运行日统计'
                },
                xAxis: {
                  type: 'category',
                  data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                },
                yAxis: {
                  type: 'value'
                },
                series: [{
                  data: [820, 932, 901, 934, 1290, 1330, 1320],
                  type: 'line'
                }]
            };
     
            myChart.setOption(option);

            var chartDom2 = this.$refs.lineChart2;
            var myChart2 = echarts.init(chartDom2);
            const option2 = {
                title: {
                  text: '运行月统计'
                },
                legend:{
                    data:['计划线路','完成线路']
                },
                xAxis: {
                  data: ['6月', '7月', '8月', '9月', '10月', '11月', '12月']
                },
                yAxis: {
                  type: 'value'
                },
                series: [
                    {
                        type: 'bar',
                        data: [56, 58, 86, 85, 67, 79, 88],
                        name: "计划线路"
                    },
                    {
                        type: 'bar',
                        data: [54, 55, 86, 80, 67, 70, 86],
                        name: "完成线路"
                    }
                ]
            };
            myChart2.setOption(option2);
        }
    },
    mounted() {
        this.initHomeData();
    }
}
</script>

<style>
.cardbox {
    margin-left: 20px;
    margin-bottom: 10px;
    border: #dddddd 1px solid;
    width: 200px;
}
.cardbox > div.title {
    padding: 10px 10px;
    background: #dddddd;
    font-size: 16px;
}
.cardbox-weight {
    color: #333333;
    font-size: 22px;
}

.patrol_row-spacing {
    width: 100%;
    height: 20px;
}

.cardchart {
    margin-left: 20px;
    margin-bottom: 10px;
    padding-top: 10px;
    border: #dddddd 1px solid;
    width: 600px;
    height: 400px;
}

.export-btn {
    float: right;
    margin-right: 10px;
}
.ex-sub { float: right; width: 5px; height: 30px;}

.abnormal-box {
    margin-top: 20px;
    margin-left: 15px;
    padding-bottom: 10px;
    width: 95%;
    border-radius: 8px;
    border: #dddddd 1px solid;
}
.abnormal-box > div.title {
    padding-top: 15px;
    padding-left: 15px;
    padding-bottom: 15px;
    border-radius: 8px;
    background-color: #5fafff;
    color: #ffffff;
    font-size: 18px;
}

.transition-box {
    float: left;
    margin-left: 15px;
    margin-bottom: 10px;
    width: 210px;
    height: 80px;
    border-radius: 8px;
    background-color: #5fafff;
    text-align: center;
    color: #fff;
    padding: 20px 10px;
    box-sizing: border-box;
    margin-right: 20px;
    font-size: 20px;
}

.page-hello-row {
    padding-left: 15px;
    margin-top: -20px;
    font-size: 16px;
    color: #666666;
}
</style>